import React, { useEffect, useRef } from "react";
import { useGoogleMaps } from "@/hooks/useGoogleMaps";
import { createStyledMap, LIMA_CENTER } from "./mapTheme";

/**
 * Mapa de solo lectura para la ruta optimizada del conductor: pines
 * dorados numerados en el orden ya calculado por el backend + polyline
 * conectándolos. Sin interacción (a diferencia de PassengerPointPicker).
 *
 * Si Maps no está configurado, no renderiza nada -- el panel de paradas
 * (lista) en DriverRoute.jsx ya se muestra siempre, con o sin mapa, así
 * que la pantalla nunca se rompe ni queda en blanco (CLAUDE.md 2c).
 */
const RouteMap = ({ stops, testId = "route-map" }) => {
  const { status } = useGoogleMaps();
  const containerRef = useRef(null);
  const mapRef = useRef(null);
  const overlaysRef = useRef([]);

  useEffect(() => {
    if (status !== "ready" || !containerRef.current || !stops?.length) return;

    if (!mapRef.current) {
      mapRef.current = createStyledMap(containerRef.current, { center: LIMA_CENTER, zoom: 12 });
    }
    const map = mapRef.current;

    overlaysRef.current.forEach((overlay) => overlay.setMap(null));
    overlaysRef.current = [];

    const bounds = new window.google.maps.LatLngBounds();
    const path = [];

    stops.forEach((stop) => {
      const position = { lat: stop.passenger_point_lat, lng: stop.passenger_point_lng };
      path.push(position);
      bounds.extend(position);

      const marker = new window.google.maps.Marker({
        position,
        map,
        label: { text: String(stop.order), color: "#0D0E10", fontWeight: "700", fontSize: "12px" },
        icon: {
          path: window.google.maps.SymbolPath.CIRCLE,
          scale: 14,
          fillColor: "#C9A227",
          fillOpacity: 1,
          strokeColor: "#0D0E10",
          strokeWeight: 2,
        },
      });
      overlaysRef.current.push(marker);
    });

    const polyline = new window.google.maps.Polyline({
      path,
      map,
      strokeColor: "#C9A227",
      strokeOpacity: 0.9,
      strokeWeight: 3,
    });
    overlaysRef.current.push(polyline);

    map.fitBounds(bounds, 48);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status, stops]);

  if (status !== "ready" || !stops?.length) return null;

  return <div ref={containerRef} className="w-full h-full min-h-[360px] rounded-xl overflow-hidden border border-[#2E2F33]" data-testid={testId} />;
};

export default RouteMap;
